import React from "react";
import { DeleteIcon } from "../../common/icons";
import { MediaItem } from "./MediaItem";

export default function MediaSection({
    gebrek,
    media = [],
    uploadError,
    onMediaUpload,
    onDeleteMedia,
}) {
    // Render each media item with a delete button
    const renderMedia = (mediaList) => {
        if (!mediaList || mediaList.length === 0) return null;
        return mediaList.map((item, idx) => (
            <div
                key={item.mediaid || item.mediaurl || item.url || `media-${gebrek.gebrekid}-${idx}`}
                className="relative"
            >
                <MediaItem mediaItem={item} />
                <button
                    onClick={() => onDeleteMedia(item.gebrekmediaid)}
                    className="absolute top-1 right-1 p-0.5 rounded hover:bg-red-100 focus:outline-none"
                    title="Verwijder Media"
                >
                    <DeleteIcon className="h-4 w-4 text-red-500 hover:text-red-700" />
                </button>
            </div>
        ));
    };

    return (
        <div>
            <h3 className="text-sm font-semibold text-gray-700 mb-2">
                Media (Gebrek):
            </h3>
            <div className="flex flex-wrap gap-4 mb-2">
                {media?.length > 0 ? (
                    renderMedia(media)
                ) : (
                    <p className="text-sm text-gray-500 italic">
                        Geen media toegevoegd aan gebrek.
                    </p>
                )}
            </div>
            <div>
                <label
                    htmlFor={`media-upload-${gebrek.gebrekid}`}
                    className="block text-sm font-medium text-gray-700 mb-1"
                >
                    Nieuwe media toevoegen (Gebrek):
                </label>
                <input
                    id={`media-upload-${gebrek.gebrekid}`}
                    type="file"
                    multiple
                    accept="image/*,video/*"
                    onChange={onMediaUpload}
                    className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
                {uploadError && (
                    <p className="text-xs text-red-600 mt-1">{uploadError}</p>
                )}
            </div>
        </div>
    );
}
